// components/MembersLayout.js
import { Outlet } from "react-router-dom";
import { NavBar } from "./NavBar";
import { useEffect, useState } from "react";

export function MembersLayout() {
  useEffect(() => {
    document.title = "GCES Member Dashboard";
  }, []);
  return (
    <>
      <div style={{fontFamily: "'Montserrat', sans-serif"}}>
        <NavBar />
        <Outlet />
      </div>
    </>
  );
}
